import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Wallet } from '@phosphor-icons/react';
import { formatAnyDate } from '../../../utils/dateFormat';

const fmtINR = (n) => '₹ ' + Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export function AdvanceAvailableDialog({ open, onOpenChange, alerts }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl bg-white max-h-[80vh] overflow-y-auto" data-testid="advance-available-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Wallet size={22} className="text-emerald-600" weight="fill" />
            Customer Advance Available
          </DialogTitle>
        </DialogHeader>
        <div className="text-xs text-zinc-600 -mt-1">
          These customers have unallocated advance payments and job-order-linked quotations with outstanding balances.
          Allocate the existing advance to settle them.
        </div>
        <div className="space-y-3">
          {(alerts || []).map((a) => (
            <div key={a.customer_mobile} className="p-3 rounded-sm border border-emerald-300 bg-emerald-50" data-testid={`advance-alert-${a.customer_mobile}`}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-bold text-sm">{a.customer_name || a.customer_mobile} <span className="font-mono text-[10px] text-zinc-500">{a.customer_mobile}</span></div>
                  <div className="text-xs mt-0.5">
                    Available Advance: <b className="text-emerald-700">{fmtINR(a.total_available)}</b>
                    <span className="mx-2">·</span>
                    Eligible Outstanding: <b className="text-red-700">{fmtINR(a.total_outstanding)}</b>
                  </div>
                </div>
                <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 h-8 text-xs"
                  onClick={() => { onOpenChange(false); navigate('/admin/receipts?tab=advances'); }}
                  data-testid={`allocate-advance-${a.customer_mobile}`}>
                  Allocate Existing Advance
                </Button>
              </div>
              <div className="mt-2 grid grid-cols-2 gap-2 text-[11px]">
                <div>
                  <div className="text-[9px] uppercase tracking-wider text-zinc-500 font-bold mb-0.5">Advance Receipts (oldest first)</div>
                  {a.receipts.map((r) => (
                    <div key={r.receipt_number} className="font-mono">{r.receipt_number} · {formatAnyDate(r.receipt_date)} · {r.payment_mode} · <b>{fmtINR(r.available)}</b></div>
                  ))}
                </div>
                <div>
                  <div className="text-[9px] uppercase tracking-wider text-zinc-500 font-bold mb-0.5">Eligible Quotations</div>
                  {a.eligible_quotations.map((q) => (
                    <div key={q.quotation_number} className="font-mono">{q.quotation_number} ({(q.jo_numbers || []).join(', ')}) · outstanding <b className="text-red-700">{fmtINR(q.outstanding_balance)}</b></div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
